export interface IVisitTypeSummary {
  visitTypeId: string;
  visitTypeDescription: string;
  visitCount: number;
}

export class VisitTypeSummary {
  visitTypeId: string;
  visitTypeDescription: string;
  visitCount: number;

  constructor(data: IVisitTypeSummary) {
    this.visitTypeId = data.visitTypeId;
    this.visitTypeDescription = data.visitTypeDescription;
    this.visitCount = data.visitCount;
  }
}
